import { isJSXElement } from "@utils/common";
import Image from "next/image";
import React from "react";

interface TitleCardProps {
    chipTitle: string;
    mainTitle: string | JSX.Element;
    description: string | JSX.Element;
    buttonText?: string;
    scrollHandler?: () => void;
}

const PageMainTitleCardV2: React.FC<TitleCardProps> = (props) => {
    const { chipTitle, mainTitle, description, buttonText, scrollHandler } = props;
    const handleButtonClick = () => {
        if (scrollHandler) {
            scrollHandler();
        }
    };
    return (
        <header className="lg:max-w-5xl w-fit lg:mx-auto lg:pt-20 pt-10">
            <div className="w-full flex flex-col items-center justify-center">
                <div
                    className="w-fit mb-2 px-3 py-0.5 flex flex-nowrap justify-center items-center lg:text-base font-bold text-green-700 bg-green-200 border border-solid border-green-600"
                    style={{ borderRadius: "50px" }}
                >
                    <h2 className="lg:text-base text-sm pr-1">{chipTitle}</h2>
                    <span className="w-5 h-5">
                        <Image
                            width={18}
                            height={18}
                            loading="lazy"
                            src="https://assets.gallabox.com/gb-home/new-zapier/wa-w-whiteborder.svg"
                            alt="white-border"
                            className="ml-2"
                        />
                    </span>
                </div>
                <h1 className="mb-6 text-3xl font-bold text-gray-700 text-center">{mainTitle}</h1>
                {isJSXElement(description) ? description : <p className="mb-4 text-base font-normal text-gray-600 text-center">{description}</p>}
                {buttonText && (
                    <button
                        className="w-fit px-6 py-2.5 box-border text-lg font-medium text-white bg-blue-500 rounded-md focus:outline-none hover:bg-blue-600 hover:shadow-md"
                        onClick={handleButtonClick}
                    >
                        {buttonText}
                    </button>
                )}
            </div>
        </header>
    );
};

export default PageMainTitleCardV2;
